import(/* webpackMode: "eager" */ "/vercel/path0/components/access-check.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileActionsToolbar"] */ "/vercel/path0/components/action-buttons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConditionLeft","MobileConditionLeft"] */ "/vercel/path0/components/conditions-l-jumbo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/content-wrapper/content-left.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/content-wrapper/content-right.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmailOptIn"] */ "/vercel/path0/components/course-subscription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CTAText","PlusLink","ExaminePlusLink","FlashSaleCTA"] */ "/vercel/path0/components/cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExamineDatabase","DatabaseBody"] */ "/vercel/path0/components/edb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/evidence-box.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileResearchers","FourResearchers"] */ "/vercel/path0/components/four-researchers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TopicsInterventionsLinks"] */ "/vercel/path0/components/list-left.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/medical-disclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MobileMenuView"] */ "/vercel/path0/components/menu-view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OtherFaqs"] */ "/vercel/path0/components/other-faqs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Overview"] */ "/vercel/path0/components/overview.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/quick-links.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["References","EDBReferences"] */ "/vercel/path0/components/references.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResearchBreakdownOutline"] */ "/vercel/path0/components/research-break.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResearchFeed"] */ "/vercel/path0/components/research-feed.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/sale-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SaveButton"] */ "/vercel/path0/components/saved-pages.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AlertDialog","AlertDialogTrigger","AlertDialogContent","AlertDialogCancel","AlertDialogHeader","AlertDialogTitle"] */ "/vercel/path0/components/ui/alert-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/alert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BreadCrumb","BreadCrumbItem"] */ "/vercel/path0/components/ui/bread-crumb.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Collapsible","CollapsibleTrigger","CollapsibleContent"] */ "/vercel/path0/components/ui/collapsible.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip","TooltipTrigger","TooltipContent"] */ "/vercel/path0/components/ui/tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SinglePageUpdate"] */ "/vercel/path0/components/update.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["fetchWrapper"] */ "/vercel/path0/lib/hooks/fetch-client.ts");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
